import { FurnitureKind } from './buildOfficeLayout';

/**
 * Theming por setor: arquétipo de cargo -> móvel do posto de trabalho.
 * Extensível — conforme a biblioteca de móveis cresce, mapeia mais arquétipos.
 * O que não tiver móvel próprio cai em 'desk' (mesa de escritório).
 */
const FURNI_BY_ARCH: Partial<Record<string, FurnitureKind>> = {
  textil: 'sewing',
  producao: 'machine',
  construcao: 'machine',
  engenharia: 'machine',
  tecnico: 'machine',
  vendas: 'counter',
  caixa: 'counter',
  atendimento: 'counter',
  bar: 'counter',
  autonomo: 'counter',
  cozinha: 'stove',
  logistica: 'shelf',
  transporte: 'shelf',
  saude: 'maca',
};

export const furniForArch = (key: string): FurnitureKind => FURNI_BY_ARCH[key] ?? 'desk';

/** Móvel "de sala" (compartilhado) por arquétipo — ex.: têxtil ganha mesa de corte. */
export const roomPropForArch = (key: string): FurnitureKind | null =>
  key === 'textil' ? 'cuttable' : null;
